import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import products from '../../assets/homeone.png'
const HomeCustomer = () => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState("mostRecent");

 const testimonials = [
    {
      id: 1,
      name: "Michael R.",
      verified: true,
      date: "2022-10-09",
      rating: 5,
      // title: "Sunscreen actually works.",
      review: "I’ve tried a lot of supplements that promised to boost energy, but ErExcel Pro actually made a difference. Within a week I felt more active and focused. It’s now part of my daily routine.",
      // product: "SPF 50 Sunscreen",
      productImage: products
    },
    {
      id: 2,
      name: "James D",
      verified: true,
      date: "2023-10-08",
      rating: 4,
      // title: "Must buy product",
      review: "After turning 40, I started noticing low energy levels. ErExcel Pro helped me feel more like myself again, energetic and motivated throughout the day. Highly recommend it!",
      // product: "Maleic Bond Repair Complex 5% Hair Mask",
      productImage: products,
      expandable: true
    },
    {
      id: 3,
      name: "Maddy",
      verified: true,
      date: "2024-10-08",
      rating: 4,
      // title: "Best product acne ke liye",
      review: "My job is demanding, and by evening I used to feel drained. Since I started using ErExcel Pro, I stay energetic and focused all day. Definitely a game changer!",
      // product: "Anti-Acne Skin Care Kit",
      productImage:products
    },
    {
      id: 4,
      name: "Brandon",
      verified: false,
      date: "2023-10-07",
      rating: 3,
      // title: "Amazing results!",
      review: "What I like about ErExcel Pro is that it’s natural and effective. My workouts feel smoother, recovery is better, and I just have that extra push every morning.",
      // product: "Vitamin C Serum",
      productImage: products
    },
    {
      id: 5,
      name: "David",
      verified: true,
      date: "2022-10-07",
      rating: 5,
      // title: "Amazing results!",
      review: "I was skeptical at first, but after a few weeks I noticed better stamina and overall vitality. It’s become my go-to supplement for daily energy and confidence",
      // product: "Vitamin C Serum",
      productImage: products
    },
    {
      id: 6,
      name: "Anthony",
      verified: true,
      date: "2025-10-07",
      rating: 3,
      // title: "Amazing results!",
      review: "ErExcel Pro really helps me stay on top of my busy schedule. I feel more alert and active, like I’ve regained my old drive and energy.",
      // product: "Vitamin C Serum",
      productImage: products
    }
  ];

  const sortedTestimonials = [...testimonials].sort((a, b) => {
    if (selectedFilter === "highestRating") return b.rating - a.rating;
    if (selectedFilter === "lowestRating") return a.rating - b.rating;
    return new Date(b.date) - new Date(a.date); 
  });

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      const newScrollLeft =
        scrollContainerRef.current.scrollLeft +
        (direction === "left" ? -scrollAmount : scrollAmount);
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full bg-white py-12 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2
            className="text-3xl md:text-4xl font-bold text-[#44576D]"
            style={{ fontFamily: "Segoe UI" }}
          >
            What Our Customers Say
          </h2>

         
        </div>

        <div className="relative">
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10  shadow-lg rounded-full p-2 bg-[#44576D] transition-colors hidden md:block"
              aria-label="Scroll left"
            >
              <ChevronLeft className="w-6 h-6 text-white bg-[#44576D]" />
            </button>
          )}

          {showRightArrow && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-#44576D shadow-lg rounded-full p-2 bg-[#44576D]  transition-colors hidden md:block"
              aria-label="Scroll right"
            >
              <ChevronRight className="w-6 h-6 text-white " />
            </button>
          )}

          <div
            ref={scrollContainerRef}
            onScroll={handleScroll}
            className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {sortedTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="flex-shrink-0 w-[85vw] md:w-[400px] bg-white border border-gray-200 rounded-2xl p-6 snap-start hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-[#44576D]">
                      {testimonial.name}
                    </span>
                    {testimonial.verified && (
                      <span className="flex items-center gap-1 text-sm text-[#44576D]">
                        <svg
                          className="w-4 h-4 text-green-600"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Verified Buyer
                      </span>
                    )}
                  </div>
                  <span className="text-sm text-gray-500">
                    {new Date(testimonial.date).toLocaleDateString()}
                  </span>
                </div>

                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-gray-900"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {testimonial.title}
                </h3> */}

                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {testimonial.review}
                  {testimonial.expandable && (
                    <span className="text-[#44576D] font-medium ml-1 cursor-pointer hover:underline">
                      Read more
                    </span>
                  )}
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-[#E6E6E6]">
                  <div className="w-16 h-16 bg-[#E6E6E6] rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={testimonial.productImage}
                      alt={testimonial.product}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="text-sm text-[#44576D] line-clamp-2">
                    {testimonial.product}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      <div className='flex flex-col items-center justify-center'>
        <button className="bg-[#44576D] text-[#ffffff] font-semibold p-10 md:px-8 py-3 md:py-4 rounded-md shadow  text-base md:text-lg mt-4">
          Claim Your Special Offer Before It Ends</button>
      </div>
    </div>
  );
};

export default HomeCustomer;
